const formatter = new Intl.NumberFormat("en-GB", {
  style: "currency",
  currency: "GBP",
});

const wholeFormatter = new Intl.NumberFormat("en-GB", {
  style: "currency",
  currency: "GBP",
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

export const formatCurrency = (amt: number) => formatter.format(amt);
export const formatWholeCurrency = (amt: number) => wholeFormatter.format(amt);
